<template>

	<v-card
		class="terminal-tab-container"
		:width="terminalWidth"
		:height="terminalHeight + 40"
	>
		<v-tabs
			v-model="activeTab"
			background-color="#E0E0E0"
			:width="terminalWidth"
			:class="isFullScreen ? 'full-screen-terminal-top' : ''"
		>
			<v-tab
				v-for="(tabIndex, index) in openTabs"
				:key="index"
				@click.stop="showEditNameDialog(index)"
			>

				<v-dialog
					v-if="activeTab === index"
					v-model="editNameDialog"
					max-width="384"
				>
					<v-card>

						<v-card-title>
							<v-icon left>
								mdi-pencil-outline
							</v-icon>
							Rename
						</v-card-title>

						<v-card-text class="d-flex">

							<v-text-field
								dense
								label="Enter Tab Name"
								outlined
								single-line
								:error="error !== null && error !== ''"
								:error-messages="error"
								v-model.trim="newTabName"
								hide-details="auto"
								class="mr-1"
							>
							</v-text-field>

							<v-btn
								class="success ml-2"
								color="success"
								@click="modifyTabName(index)"
							>
								Update
							</v-btn>

						</v-card-text>

					</v-card>

				</v-dialog>

				<span class="subtitle-2">
					{{ $store.getters.getTabNames[index] }}
				</span>

				<v-icon
					size="7"
					class="ml-2 pa-1"
					@click="closeTab(index)"
				>
					mdi-checkbox-blank-circle
				</v-icon>

			</v-tab>

			<v-icon
				small
				@click="openNewTab()"
			>
				mdi-plus
			</v-icon>

			<v-spacer></v-spacer>

			<!--v-icon
				class="px-5"
				right
				@click="changeFontSize(+1)"
			>
				mdi-magnify-plus-outline
			</v-icon>

			<v-icon
				class="pr-5"
				right
				@click="changeFontSize(-1)"
			>
				mdi-magnify-minus-outline
			</v-icon-->

			<v-icon
				right
				@click="toggleIframeExpandState()"
				v-if="!isFullScreen"
				class="px-5"
			>
				mdi-arrow-expand
			</v-icon>

			<v-icon
				right
				@click="toggleIframeExpandState()"
				class="px-5"
				v-else
			>
				mdi-arrow-collapse
			</v-icon>

		</v-tabs>

		<div
			v-if="openTabs && openTabs.length !== 0"
		>

			<div
				v-for="index in openTabIndex"
				:key="index"
				:class="isFullScreen ? 'full-screen-terminal-container' : ''"
			>

				<iframe
					v-if="openTabs.includes(index)"
					class="terminal-iframe"
					:id="`terminal-${index}`"
					:width="actualTerminalWidth"
					:height="actualTerminalHeight"
					:src="$store.getters.getLabURL"
					v-show="isAliveTerminal(index)"
					:class="isFullScreen ? 'full-screen-terminal-body' : ''"
				>
				</iframe>

			</div>

		</div>

	</v-card>

</template>

<script>

export default {
	name: "Terminal",
	props: {
		reset: Boolean,
		terminalWidth: Number,
		terminalHeight: Number,
	},
	data() {
		return {
			tabCount: 1,
			activeTab: 0,
			openTabIndex: 1,
			openTabs: [1],
			editNameDialog: false,
			newTabName: null,
			error: null,
			isFullScreen: false,
			modifier: 336,
			actualTerminalWidth: 0,
			actualTerminalHeight: 0,
			justClosedATab: false,
		};
	},
	watch: {
		reset(val) {
			if (val) {
				this.resetTerminal();
			}
		}
	},
	created() {
		// Reset Terminal function would also
		// set up the actual terminal width and
		// height for us!
		this.resetTerminal();
	},
	methods: {

		initTerminalSize() {
	    	this.actualTerminalWidth = this.terminalWidth;
	    	this.actualTerminalHeight = this.terminalHeight;
		},
		changeFontSize(direction) {
			this.actualTerminalHeight += direction * this.modifier;
			this.actualTerminalWidth += direction * this.modifier;
		},
		toggleIframeExpandState() {

			this.$emit("set-transform-animations", this.isFullScreen);
			this.isFullScreen = !this.isFullScreen;

			// this.initTerminalSize();
		},
	    showEditNameDialog(index) {

	    	if (this.justClosedATab) {
	    		this.justClosedATab = false;
	    		return;
	    	}

			if (this.activeTab !== index) {
				this.activeTab = index;
				return;
	    	}

			/* eslint-disable no-console */
			//console.log(index);
			/* eslint-enable no-console */

			this.error = null;
			this.editNameDialog = true;
			this.newTabName = this.$store.getters.getTabNames[this.activeTab];
	    },
	    openNewTab() {

	    	this.justClosedATab = false;
			this.tabCount++;
			this.openTabIndex++;

			this.activeTab = this.tabCount - 1;

			/* eslint-disable no-console */

			/*
			console.log("---=====================================---");
			console.log("this.$store.getters.getTabNames: " + this.$store.getters.getTabNames);
			console.log("this.$store.getters.getTabNames.length: " + this.$store.getters.getTabNames.length);
			console.log("this.tabCount: " + this.tabCount);
			console.log("Name: " + "terminal-" + this.openTabIndex);
			console.log("Index: " + this.openTabs[this.activeTab - 1]);
			console.log("---=====================================---");
			*/

			/* eslint-enable no-console */

			if (this.$store.getters.getTabNames.length >= this.tabCount) {
				this.$store.dispatch("setTabName", {
					"name": "attacker-" + this.openTabIndex,
					"index": this.tabCount - 1
				});
			}
			else {
				this.$store.dispatch("addToTabName", "attacker-" + this.openTabIndex);
			}

			// Logic to open a new tab!

			this.openTabs.push(this.openTabIndex);

			/*
			if (!(this.openTabIndex in this.openTabs)) {
				//this.openTabs[this.tabCount - 1] = this.openTabIndex;
			}
			*/

	    },
	    closeTab(index) {

			// index goes like: 1, 2, 3, ...

			/* eslint-disable no-console */
			//console.log("Index: " + index);
			/* eslint-enable no-console */

			this.justClosedATab = true;
			this.tabCount--;

			/*
			if (index === this.openTabs.length - 1) {
				this.openTabIndex--;
			}
			*/

			this.$store.dispatch("removeTabName", index);
			this.openTabs.splice(index, 1);

			this.openTabIndex = Math.min(this.openTabIndex, this.openTabs[this.openTabs.length - 1]);

			if (this.openTabs.length === 0) {
				// Emit an Event here!!!
				// this.stopLab();
				// OR MAYBE BETTER -
				// Open another tab!

				// Here, justClosedATab is set to false!
				// This is because when no tab is there the
				// dummy click event won't fire up!
				this.justClosedATab = false;

				this.openTabIndex = 0;
				setTimeout(() => this.openNewTab(), 0.0001);
				return;
			}

			this.activeTab = Math.min(index, this.openTabs.length - 1);

			if (index > this.activeTab) {
				// Moving backwards!
				this.justClosedATab = false;
			}
			else {
				// Moving forwards!
				this.justClosedATab = true;
			}

	    },
	    resetTerminal() {

	    	this.initTerminalSize();

			this.tabCount = 1;
			this.activeTab = 0;

			this.isFullScreen = false;

			this.openTabIndex = 1;
			this.openTabs = [1];

			this.$store.dispatch("initTabNames");

	    },
		isAliveTerminal(index) {

			let is_tab_open = this.openTabs.includes(index);
			let is_tab_active = (this.openTabs[this.activeTab] === index);

			/* eslint-disable no-console */
			/*
			console.log("---================================---");
			console.log("Index: " + index);
			console.log("Active Tab: " + this.activeTab);
			console.log("Open Tabs: " + this.openTabs);

			console.log("is_tab_open: " + is_tab_open);
			console.log("is_tab_active: " + is_tab_active);
			console.log("---================================---");
			*/
			/* eslint-enable no-console */

			return (is_tab_open && is_tab_active);
		},
		modifyTabName(index) {

			this.error = null;

			if (this.newTabName === null || this.newTabName === "") {
				this.error = "Empty names are not allowed!";
				return;
			}

			let nameIndexPair = {
				"name": this.newTabName,
				"index": index
			};

			this.$store.dispatch("setTabName", nameIndexPair);

			this.editNameDialog = false;
			this.newTabName = null;
		},
	}
};

</script>

<style>
/*
@import "../../public/css/style.css";
*/
</style>